import React, { useState } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import { useLang } from '../context/LangContext';
import { colors, fonts, radius, transition } from '../styles/tokens';

function ContactPage() {
  const { t } = useLang();
  const c = t.contact;

  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  function handleChange(e) {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    // TODO: wire to Firebase / email service
    console.log('Contact form:', form);
    setSubmitted(true);
  }

  const inputStyle = {
    width: '100%',
    padding: '14px 16px',
    borderRadius: radius.md,
    border: `1px solid ${colors.border}`,
    fontFamily: fonts.body,
    fontSize: 15,
    color: colors.text,
    background: '#fff',
    outline: 'none',
    transition: transition.default,
    display: 'block',
    marginBottom: 16,
  };

  return (
    <>
      <Navbar />
      <main style={{ paddingTop: 80 }}>
        <div style={{ padding: '60px 24px 0', background: 'linear-gradient(135deg, #060618, #D60B0B)', textAlign: 'center' }}>
          <div style={{ maxWidth: 800, margin: '0 auto', paddingBottom: 60 }}>
            <h1 style={{ fontFamily: fonts.display, fontSize: 'clamp(28px, 5vw, 48px)', fontWeight: 900, color: '#fff', margin: '0 0 12px' }}>
              {c.heading}
            </h1>
            <p style={{ fontFamily: fonts.body, fontSize: 16, color: 'rgba(255,255,255,0.6)' }}>
              {c.subheading}
            </p>
          </div>
        </div>

        <div style={{ maxWidth: 640, margin: '0 auto', padding: '64px 24px 96px' }}>
          {submitted ? (
            <div style={{ textAlign: 'center', padding: '48px 24px', background: '#fff', borderRadius: 20, border: `1px solid ${colors.border}` }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
              <h2 style={{ fontFamily: fonts.display, fontSize: 22, fontWeight: 700, color: colors.text, marginBottom: 8 }}>
                {c.successMsg}
              </h2>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ background: '#fff', padding: '40px', borderRadius: 20, border: `1px solid ${colors.border}` }}>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder={c.namePlaceholder}
                required
                style={inputStyle}
              />
              <input
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder={c.emailPlaceholder}
                required
                style={inputStyle}
              />
              <input
                name="subject"
                value={form.subject}
                onChange={handleChange}
                placeholder={c.subjectPlaceholder}
                required
                style={inputStyle}
              />
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder={c.messagePlaceholder}
                required
                rows={5}
                style={{ ...inputStyle, resize: 'vertical', marginBottom: 24 }}
              />
              <button
                type="submit"
                style={{
                  width: '100%',
                  padding: '16px',
                  borderRadius: radius.full,
                  background: colors.red,
                  color: '#fff',
                  fontFamily: fonts.body,
                  fontWeight: 700,
                  fontSize: 15,
                  border: 'none',
                  cursor: 'pointer',
                  transition: transition.default,
                }}
                onMouseEnter={e => e.target.style.background = colors.redDark}
                onMouseLeave={e => e.target.style.background = colors.red}
              >
                {c.submitButton}
              </button>
            </form>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}

export default ContactPage;
